import React, { createContext, useState, useEffect, useContext } from "react";
import io from "socket.io-client";

import useInterval from "../hooks/useInterval";

import { withRouter, useHistory } from "react-router-dom";
import { 
  GAME_STATE_CHOOSING_CARDS,
  GAME_STATE_REVEALING_CARDS,
  GAME_STATE_ALL_CARDS_CHOOSEN,
  GAME_STATE_NEW_ROUND,
  NEW_CARD_VALUE,
  AI_MESSAGE,
  AI_COMMENT,
  AI_FACT
} from "./constants";
import { AuthContext } from "./AuthContext";
import { addItemToArray, getItemsFromArray } from "../lib/localStorageHelper";

export const SocketContext = createContext();

const socketUrl = `${process.env.REACT_APP_URL}:${process.env.REACT_APP_SOCKET_PORT}`;

function SocketProvider({ children }) {
  const history = useHistory();
  const [socket, setSocket] = useState(null);

  const [isHost, setIsHost] = useState(false);
  const [averageScore, setAverageScore] = useState(null);
  const [valuesAgreement, setValuesAgreement] = useState([]);
  const [maxPercentage, setMaxPercentage] = useState(null);
  const [message, setMessage] = useState(null);
  
  const [cardValue, setCardValue] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const [cardStyle, setCardStyle] = useState(false);

  const [gameState, setGameState] = useState(GAME_STATE_CHOOSING_CARDS);
  
  const [delay, setDelay] = useState(null);
  const [countdown, setCountdown] = useState(3);
  const [counting, setCounting] = useState(false);

  const { username } = useContext(AuthContext);
  const [joinedRooms, setJoinedRooms] = useState([]);

  const parotSources = {
    good: "https://cultofthepartyparrot.com/parrots/hd/ultrafastparrot.gif",
    sleepy: "https://cultofthepartyparrot.com/parrots/hd/sleepingparrot.gif",
    sad: "https://cultofthepartyparrot.com/parrots/hd/sadparrot.gif",
    angry: "https://cultofthepartyparrot.com/parrots/hd/angryparrot.gif",
    idle: "https://cultofthepartyparrot.com/parrots/hd/parrot.gif"
  };
  const parrotWords = {
    good: "Party!!!",
    sleepy: "Meh..",
    sad: "I am sad now.",
    angry: "Parrot Angry."
  };

  const [src, setSrc] = useState(parotSources["idle"]);
  const [word, setWord] = useState(parrotWords["good"]);

  useInterval(() => {
    setCountdown(countdown - 1);
    if (countdown <= 1){
      setDelay(null);
      setCounting(false);
      if (gameState === GAME_STATE_REVEALING_CARDS) {
        getParrotReaction();
      }
    }
  }, delay);


  const createRoom = () => {
    // Every user that gets a socket also gets a room, so the host is redirected to his room
    // and other users connect to his room via link. Since socket is created in this function, users 
    // that are not the host must use createSocket function and call it after joining 

    const socket = io(socketUrl, {transports: ["websocket", "polling", "flashsocket"]});
    
    socket.on("connect", () => { 
      console.log("connected");
      setSocket(socket);
      setMessage(null);
      addItemToArray(`joinedRooms-${username}`, socket.id, {}, 12);
      history.push(`${socket.id}`);
    });
    setIsHost(true);  
  };

  const createSocket = () => {
    const socket = io(socketUrl, {transports: ["websocket", "polling", "flashsocket"]});
    
    socket.on("connect", () => { 
      console.log("connected");
      
      setSocket(socket);
      addItemToArray("joinedRooms", socket.id, {}, 12);
    });
  };

  const getParrotReaction = () => {
    console.log("YO PARROT REACTS");
    if (maxPercentage > 80){
      setSrc(parotSources["good"]);
      setWord(parrotWords["good"]);
    } else if (maxPercentage > 60) {
      setSrc(parotSources["sleepy"]);
      setWord(parrotWords["sleepy"]);
    } else if (maxPercentage > 40) {
      setSrc(parotSources["sad"]);
      setWord(parrotWords["sad"]);
    } else if (maxPercentage > 20) {
      setSrc(parotSources["angry"]);
      setWord(parrotWords["angry"]);
    } else {
      setSrc(parotSources["angry"]);
      setWord(parrotWords["angry"]);
    }
  };

  const changeCardValue = (value) => {
    setCardValue(value);
    socket.emit(NEW_CARD_VALUE, { cardValue: value });
  };

  const revealCards = () => {
    socket.emit(GAME_STATE_REVEALING_CARDS, true );
  };

  const startNewRound = () => {
    setGameState(GAME_STATE_NEW_ROUND);
    setMaxPercentage(null);
    setSrc(parotSources["idle"]);
    socket.emit(GAME_STATE_NEW_ROUND, true );
  };

  const startCountdown = () => {
    setCounting(true);
    setCountdown(3);
    setDelay(600);
  };

  const resetData = () => {
    setSrc(parotSources["idle"]);
    setCardValue(null);
    setSelectedCard(null);
    setMessage(null);
  };

  useEffect(() => {
    setJoinedRooms(getItemsFromArray(`joinedRooms-${username}`));
    if (!socket) return null;

    socket.on(GAME_STATE_REVEALING_CARDS, (data) => { 
      startCountdown();
      console.log(GAME_STATE_REVEALING_CARDS);
      console.log(data);
      setAverageScore(data.average);
      console.log(data.cardValuesAgreement);
      setValuesAgreement(data.cardValuesAgreement);
      setMaxPercentage(data.maxPercentage);
      setGameState(GAME_STATE_REVEALING_CARDS);
    });

    socket.on(AI_COMMENT, (data) => { 
      console.log("AI DATA", data);
      setMessage(data.message);
    });

    socket.on(GAME_STATE_CHOOSING_CARDS, () => { 
      console.log(GAME_STATE_CHOOSING_CARDS);
      setGameState(GAME_STATE_CHOOSING_CARDS);
    });

    socket.on(GAME_STATE_ALL_CARDS_CHOOSEN, () => { 
      console.log(GAME_STATE_ALL_CARDS_CHOOSEN);
      setGameState(GAME_STATE_ALL_CARDS_CHOOSEN);
    });

    socket.on(GAME_STATE_NEW_ROUND, () => { 
      setGameState(GAME_STATE_CHOOSING_CARDS);
      setCardValue(null);
      setSelectedCard(null);
      setMessage(null);
    });

    // socket.on(AI_FACT, (data) => { 
    //   setMessage(data.message);
    // });
  }, [socket]);

  const props = {
    socket,
    createRoom,
    createSocket,
    isHost,
    setIsHost,
    changeCardValue,
    cardValue,
    revealCards,
    gameState,
    startNewRound,
    selectedCard,
    setSelectedCard,
    averageScore,
    valuesAgreement,
    maxPercentage,
    countdown,
    counting,
    cardStyle,
    setCardStyle,
    joinedRooms,
    message,
    parrotImageSrc: src,
    parrotWord: word,
    resetData
  };

  return (
    <SocketContext.Provider value={{ ...props }}>
      {children}
    </SocketContext.Provider>
  );
}
export default withRouter(SocketProvider);
